import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { Cpu, Code, GraphUp, People } from 'react-bootstrap-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Particles from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import MarketingLayout from '../components/layout/MarketingLayout';

const LandingPage = () => {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const particlesOptions = {
    background: { color: { value: 'transparent' } },
    fpsLimit: 120,
    interactivity: {
      events: {
        onClick: { enable: true, mode: 'push' },
        onHover: { enable: true, mode: 'repulse' },
        resize: true,
      },
      modes: {
        push: { quantity: 4 },
        repulse: { distance: 200, duration: 0.4 },
      },
    },
    particles: {
      color: { value: '#ffffff' },
      links: { color: '#ffffff', distance: 150, enable: true, opacity: 0.5, width: 1 },
      move: {
        direction: 'none',
        enable: true,
        outModes: { default: 'bounce' },
        random: false,
        speed: 2,
        straight: false,
      },
      number: { density: { enable: true, area: 800 }, value: 80 },
      opacity: { value: 0.5 },
      shape: { type: 'circle' },
      size: { value: { min: 1, max: 5 } },
    },
    detectRetina: true,
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <MarketingLayout>
      <section className="marketing-hero">
        <Container>
          <h1 className="display-4">Welcome to Garden Sync</h1>
          <p className="lead">Real-time data. Smart automations. Better plants.</p>
          <div className="marketing-hero__actions">
            <Button as={Link} to="/register" variant="secondary" size="lg">
              Get Started
            </Button>
            <Button as={Link} to="/about" variant="outline-primary" size="lg">
              Learn More
            </Button>
          </div>
        </Container>
      </section>

      <section className="feature-section open-source-hardware" data-aos="slide-left">
        <div className="feature-diagonal left open-source">
          <div className="text-content-left" data-aos="fade-in" data-aos-delay="300">
            <h2><Cpu className="me-2" />Open Source Hardware</h2>
            <p>Build and customize your own garden monitoring systems using IoT devices*. Learn from our community of makers and contributors.</p>
            <small className="text-muted">*Support for ESP32 and ESP32-S3 only. Please use amazon affiliate links in our shop page to help us support more.</small>
          </div>
        </div>
      </section>

      <section className="feature-section easy-programming" data-aos="slide-right">
        <div className="feature-diagonal right easy-programming">
          <div className="text-content-right" data-aos="fade-in" data-aos-delay="300">
            <h2><Code className="me-2" />Easy Programming</h2>
            <p>No coding required! Use our intuitive interface to program your devices with simple combo box selections. Set up watering schedules, alerts, and more without writing a single line of code.</p>
          </div>
        </div>
      </section>

      <section className="feature-section real-time-data" data-aos="slide-left">
        <div className="feature-diagonal left real-time">
          <div className="text-content-left" data-aos="fade-in" data-aos-delay="300">
            <h2><GraphUp className="me-2" />Real Time Data</h2>
            <p>Monitor your garden&apos;s health in real-time with live sensor data. View interactive charts, receive instant alerts, and make data-driven decisions to keep your plants thriving.</p>
          </div>
        </div>
      </section>

      <section className="feature-section community-forum" data-aos="slide-right">
        <Particles id="tsparticles" init={particlesInit} options={particlesOptions} />
        <div className="feature-diagonal right community">
          <div className="text-content-right" data-aos="fade-in" data-aos-delay="300">
            <h2><People className="me-2" />Community Forum</h2>
            <p>Join our vibrant community of gardeners and tech enthusiasts. Share tips, troubleshoot issues, showcase your setups, and collaborate on new features.</p>
            <Button
              href="https://community.gardensync.com/communities/groups/garden-sync-community"
              target="_blank"
              rel="noopener noreferrer"
              variant="primary"
              size="lg"
              className="mt-3"
              data-aos="bounce-in"
              data-aos-delay="600"
            >
              Join the Community
            </Button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default LandingPage;